import tw from 'twin.macro';

export const Wrapper = tw.div`lg:px-6 px-2 pb-10`;

export const Welcome = tw.h3`text-center text-primary 
lg:text-lg lg:-mt-4 -mt-2 font-bold tracking-wide uppercase`;

export const Title = tw.h4`lg:ml-4 mb-4 lg:mb-6 lg:text-xl 2xl:text-2xl tracking-wide`;

export const Form = tw.form`lg:w-11/12 w-full flex flex-col`;

export const Label = tw.label`text-base font-bold`;

export const Input = tw.input`border border-gray-700 rounded-lg p-2`;

export const LoginButton = tw.button`text-center
 font-semibold lg:py-3 py-2 text-white! rounded-lg lg:mt-6 mt-4 lg:text-xl
  text-base bg-[#1a73e3] text-gray-800`;
